import { EmptyState } from '@app/components/base/EmptyState';
import InboxIcon from '@mui/icons-material/Inbox';
import { Box } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import {
  NOTIFICATION_FEED_SKELETON_COUNT,
  NotificationFeedListSkeleton,
} from './NotificationFeedListSkeleton';

const emptyMessage = defineMessage({
  id: 'core.sidenav.notificationsEmpty',
  defaultMessage: 'No hay notificaciones',
});

/**
 * Empty feed placeholder sized to match the loading skeleton so the popover
 * does not jump when the feed finishes loading with no items.
 */
export function NotificationFeedEmptyState() {
  return (
    <Box sx={{ display: 'grid' }}>
      {/* Invisible skeleton locks height to the loading state. */}
      <Box sx={{ gridArea: '1 / 1', visibility: 'hidden', pointerEvents: 'none' }} aria-hidden>
        <NotificationFeedListSkeleton count={NOTIFICATION_FEED_SKELETON_COUNT} />
      </Box>
      <Box
        sx={{
          gridArea: '1 / 1',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <EmptyState
          icon={InboxIcon}
          message={false}
          help={<FormattedMessage {...emptyMessage} />}
          compact
          centered
        />
      </Box>
    </Box>
  );
}
